module.exports = __webpack_public_path__ + "img/cars-frame.2af1babd.gif";